import classnames from "classnames";
import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { ComponentStyles } from "../../../helpers/constants/styles";
import { ComponentColor } from "../../../helpers/constants/types";

export type ButtonProps = {
  theme?: ComponentColor;
  rounded?: "normal" | "full";
  unstyled?: boolean;
} & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

function Button({ rounded, unstyled, ...props }: ButtonProps) {
  return (
    <button
      {...props}
      className={classnames(
        ComponentStyles[props.theme ?? "primary"],
        rounded === "full" && "!rounded-full",
        props.className,
      )}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

export default Button;
